import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white p-2 rounded-md"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <CommonCloseBtn
            onClose={() => {
              closeModal();
            }}
          />
          <h2 className="text-center font-bold text-lg">Menu Details</h2>

          {/* Tab Content */}
          <div className="p-4 max-h-96">
            {activeTab === "1" && (
              <div className="flow-root rounded-lg border border-gray-300 dark:border-gray-600 py-3 shadow-sm ml-5 mr-5 mb-5">
                <dl className="text-sm dark:text-white">
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      Parent Name
                    </dt>
                    <dd className="dark:text-white text-gray-700 sm:col-span-2 pl-20">
                      {result?.id_parent}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      id_sub_parent
                    </dt>
                    <dd className="dark:text-white text-gray-700 sm:col-span-2 pl-20">
                      {result?.id_sub_parent}
                    </dd>
                  </div>

                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      name
                    </dt>
                    <dd className="dark:text-white text-gray-700 sm:col-span-2 pl-20">
                      {result?.name}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      position
                    </dt>
                    <dd className="dark:text-white text-gray-700 sm:col-span-2 pl-20">
                      {result?.position}
                    </dd>
                  </div>
                  <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                    <dt className="font-medium text-gray-900 dark:text-white">
                      is_active
                    </dt>
                    <dd className="dark:text-white text-gray-700 sm:col-span-2 pl-20">
                      {result?.is_active}
                    </dd>
                  </div>
                </dl>
              </div>
            )}

            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                  <button
                    onClick={closeZoomModal}
                    className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white"
                  >
                    <IoIosClose />
                  </button>

                  <img
                    src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                    alt="Selected Company Logo"
                    className="w-full h-auto rounded-lg"
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
